import { I18nProviderElement } from "../i18n/provider-element.js";
import { safeDefine } from "../registration/safe-define.js";
import { MediaTextElement as TextElement } from "../ui/text/element.js";
//#region src/define/i18n.ts
safeDefine(I18nProviderElement);
safeDefine(TextElement);
//#endregion

//# sourceMappingURL=i18n.js.map